import { styled } from "styled-components";

export const ItensContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 60px;
  width: calc(100% - 260px);
  border-radius: 40px;

  .box {
    padding: 40px;
    width: 100%;
    height: 700px;
    background-color: var(--base);
    border-radius: 18px;
  }

  h1 {
    font-size: 38px;
    font-weight: 700;
    margin-bottom: 5px;
    margin-left: 10px;
    color: var(--principal);
  }

  .filtro {
    display: flex;
    align-items: center;
    gap: 20px;
    width: 50%;

    input {
      border: none;
      padding: 10px;
      border-radius: 50px;
      width: 70%;
      height: 40px;
    }

    div {
      align-items: center;
      justify-content: center;
      display: flex;
      flex-direction: column;
      margin-bottom: 25px;
      width: 35%;

      > p {
        font-size: 0.8rem;
        margin-bottom: 8px;
      }
    }

    select,
    option {
      width: 161px;
      padding: 5px;
      border-radius: 6px;
      border: none;
      outline: none;
      background: var(--amarelo);
      text-align: center;
      font-size: 0.8rem;
      color: var(--base);
      font-weight: 200;
    }
  }
`;

export const BoxFiltros = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  button {
    background-color: var(--principal);
    color: var(--base);
    width: 20%;
    font-size: 0.8rem;
    font-weight: 600;
    padding: 8px;
    border: none;
    border-radius: 20px;
  }
`;
